import { useRef } from "react";
import { Button as DayButton, useDayRender } from "react-day-picker";

// Use the library's rendering hook so disabled days, focus and keyboard
// selection stay identical to its default Day component.
export const CalendarDay = ({ date, displayMonth, testId }) => {
  const buttonRef = useRef(null);
  const day = useDayRender(date, displayMonth, buttonRef);
  const isoDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  const id = `${testId}-day-${isoDate}`;
  if (day.isHidden) return <div role="gridcell" />;
  if (!day.isButton) return <div {...day.divProps} data-testid={id} />;
  return <DayButton name="day" ref={buttonRef} {...day.buttonProps} data-testid={id} />;
};